export default __webpack_public_path__ + "static/cert-icon-04-2d4b649cf5fda61f0b03d15fb209d733.png";